// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Cg8m","content":"styles_content__36-Py","row":"styles_row__N2Xb-","footer":"styles_footer__34zjp","phraseLength":"styles_phraseLength__2HXdM"};